/*
  CB 16/10/2026 - Percorso prodotto (breadcrumb) sopra le foto, solo su mobile.
  Mostra la strada che il cliente ha fatto per arrivare al prodotto, presa dal menu
  principale (main-menu-nuovo), senza la voce di primo livello. Esempi:
    Prodotti > Hair Care > Shampoo > SALIX  ->  Hair Care > Shampoo > SALIX Shampoo
    Prodotti > Merchandise > Shopper        ->  Merchandise > Shopper > ...
  Come si capisce da dove arriva:
  1) link prodotto aperto da una collezione (/collections/x/products/y): collezione x
     (dato passato dal tema, script #cb-bc-data in layout/theme.liquid);
  2) altrimenti l'ultima collezione visitata in questa visita (sessionStorage),
     solo se il prodotto ne fa parte;
  3) altrimenti (prodotto aperto da home, ricerca, link esterno...) il percorso del
     ramo "Prodotti" del menu, il piu' preciso possibile; se il prodotto non e' nel
     ramo Prodotti, il percorso piu' preciso degli altri rami (esclusi Novita',
     Promozioni e Tutti i prodotti).
  Se la stessa collezione compare in piu' rami del menu (es. Prodotti ed Esigenze),
  vince il ramo da cui il cliente ha cliccato (ricordato al clic sul menu), poi Prodotti.
  Stile in assets/cb-fixes-1510d.css (blocco 15).
*/
(function () {
  var KEY_COL = 'cbBcCol'
  var KEY_MENU = 'cbBcMenu'
  var MAIN_BRANCH = 'prodotti'
  var SKIP_FALLBACK = ['all', 'novita', 'promozioni']
  var UPPER = ['neutra-senza-profumo', 'blu-sun', 'blu-products']

  function norm(u) {
    if (!u) return ''
    try { u = new URL(u, location.origin).pathname } catch (e) {}
    u = u.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '')
    return decodeURIComponent(u).replace(/\/+$/, '').toLowerCase() || '/'
  }
  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim() }
  function store(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)) } catch (e) {} }
  function read(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null') } catch (e) { return null } }
  function drop(k) { try { sessionStorage.removeItem(k) } catch (e) {} }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    })
  }
  // stessa regola del menu (assets/cb-menu-case.js): NEUTRA - senza profumo, BLU SUN...
  function title(t, u) {
    var h = (norm(u).match(/^\/collections\/([^/]+)$/) || [])[1]
    if (!h || UPPER.indexOf(h) === -1) return t
    var i = t.indexOf(' - ')
    return i === -1 ? t.toUpperCase() : t.slice(0, i).toUpperCase() + t.slice(i).toLowerCase()
  }

  var path = norm(location.pathname)
  var colMatch = path.match(/^\/collections\/([^/]+)$/)
  var isProduct = /\/products\//.test(path)

  // ricorda il ramo del menu cliccato (desktop e mobile)
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null
    if (!a || !a.closest('.site-nav, .slide-nav__wrapper, .megamenu')) return
    var top = ''
    var li = a.closest('.site-nav__item')
    if (li) {
      var tl = li.querySelector('.site-nav__link')
      top = tl ? tl.textContent : ''
    } else {
      var dd = a.closest('.slide-nav__dropdown[data-level="2"]')
      if (dd) {
        var btn = document.querySelector('.slide-nav__button[data-target="' + dd.getAttribute('data-parent') + '"] .slide-nav__link > span:not(.icon__fallback-text):not(.slide-nav__image)')
        top = btn ? btn.textContent : ''
      }
    }
    store(KEY_MENU, { u: norm(a.getAttribute('href')), top: clean(top).toLowerCase() })
  }, true)

  if (colMatch) {
    var h = colMatch[1]
    var heading = document.querySelector('#MainContent .cb-collection-intro .section-header__title') ||
      document.querySelector('#MainContent .section-header__title')
    var t = heading ? clean(heading.textContent) : document.title.split(/\s[–-]\s/)[0]
    var menu = read(KEY_MENU)
    store(KEY_COL, { h: h, t: t, u: '/collections/' + h, top: menu && menu.u === '/collections/' + h ? menu.top : '' })
    return
  }
  if (!isProduct) { drop(KEY_COL); return }

  var dataEl = document.getElementById('cb-bc-data')
  if (!dataEl) return
  var data
  try { data = JSON.parse(dataEl.textContent) } catch (e) { return }

  // tutti i percorsi del menu: [[liv1, liv2, liv3], ...]
  var paths = []
  ;(function walk(nodes, trail) {
    for (var i = 0; i < (nodes || []).length; i++) {
      var n = { t: nodes[i].t, u: nodes[i].u }
      var tr = trail.concat([n])
      paths.push(tr)
      walk(nodes[i].c, tr)
    }
  })(data.menu, [])

  function topOf(p) { return clean(p[0].t).toLowerCase() }
  function score(p, top) {
    return (top && topOf(p) === top ? 1000 : 0) + (topOf(p) === MAIN_BRANCH ? 100 : 0) + p.length
  }
  function findPath(u, top) {
    u = norm(u)
    var best = null
    for (var i = 0; i < paths.length; i++) {
      var p = paths[i]
      if (norm(p[p.length - 1].u) !== u) continue
      if (!best || score(p, top) > score(best, top)) best = p
    }
    return best
  }

  var cols = data.cols || []
  function inProduct(h) { return h === 'all' || cols.some(function (c) { return c.h === h }) }

  var source = null
  if (data.col && data.col.h) source = { h: data.col.h, t: data.col.t, u: '/collections/' + data.col.h, top: '' }
  var last = read(KEY_COL)
  if (last && (!source || source.h === last.h) && inProduct(last.h)) source = last

  var trail = null
  if (source) {
    trail = findPath(source.u, source.top) ||
      [{ t: source.h === 'all' ? 'Tutti i prodotti' : source.t, u: source.u }]
  } else {
    var best = null
    for (var i = 0; i < cols.length; i++) {
      if (SKIP_FALLBACK.indexOf(cols[i].h) !== -1) continue
      var fp = findPath(cols[i].u, '')
      if (fp && (!best || score(fp, '') > score(best, ''))) best = fp
    }
    trail = best
  }
  if (!trail || !trail.length) return
  if (trail.length > 1) trail = trail.slice(1)   // senza "Prodotti" / "Esigenze" / "Linee"

  var html = ''
  for (var j = 0; j < trail.length; j++) {
    html += '<a href="' + esc(trail[j].u) + '">' + esc(title(trail[j].t, trail[j].u)) + '</a><span class="cb-bc__sep" aria-hidden="true">›</span>'
  }
  html += '<span class="cb-bc__cur" aria-current="page">' + esc(data.product.t) + '</span>'

  function mount() {
    var grid = document.querySelector('#MainContent .product-grid__container')
    if (!grid || grid.parentElement.querySelector(':scope > .cb-bc')) return
    var nav = document.createElement('nav')
    nav.className = 'cb-bc'
    nav.setAttribute('aria-label', 'Percorso')
    nav.innerHTML = html
    grid.parentElement.insertBefore(nav, grid)
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount)
  else mount()
})()